import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
The main entry point for the About Us page
Referenced by the page.about.liquid template.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import cdnSrc from './utils/cdnSrc';
import About from './components/About';
import { jsx as _jsx } from "react/jsx-runtime";
var props = {
  activeSection: 0,
  image: cdnSrc('images/pages/about-us/refresh/Desktop-10-pct.png'),
  sections: [{
    id: 'header'
  }, {
    id: 'mission',
    title: 'mission',
    numeral: 'I.'
  }, {
    id: 'values',
    title: 'values',
    numeral: 'II.'
  }, {
    id: 'joinus',
    title: 'Join Us',
    numeral: 'III.'
  }, {
    id: 'footer'
  }]
};
var hash = window.location.hash;

if (hash.length) {
  switch (window.location.hash) {
    case 'mission':
      props.activeSection = 1;
      break;

    case 'values':
      props.activeSection = 2;
      break;

    case 'joinus':
      props.activeSection = 3;
      break;

    default:
      props.activeSection = 0;
      break;
  }
}

ReactDOM.render( /*#__PURE__*/_jsx(About, _objectSpread({}, props)), document.getElementById('about'));